<template>
  <v-dialog v-model="show" :max-width="isMobile ? '650px': '800px'" :persistent="persistent">
    <v-card>
      <v-card-title style="word-break: normal !important; justify-content: center;">{{ modalTitle }}</v-card-title>
      <v-card-text :class="centerText ? 'text-center' : 'text-left'">{{ modalText }}</v-card-text>
      <slot></slot>
      <v-card-actions class="pa-0">
        <v-btn
          :disabled="loading"
          :loading="loading"
          class="ml-0"
          :color="reversePrimary ? 'secondary' : 'primary'"
          style="width: 50%;"
          tile
          @click="emitDecision('yes')"
        >{{ $t('components.modal.btn.yes') }}
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          class="ml-0"
          :color="reversePrimary ? 'primary' : 'secondary'"
          style="width: 50%;"
          tile
          @click="emitDecision('no')"
        >{{ $t('components.modal.btn.no') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'confirmationDialog',
  props: {
    title: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: undefined
    },
    value: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    reversePrimary:{
      type:Boolean,
      default: false
    },
    centerText:{
      type:Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    modalTitle: function () {
      if (!this.title) {
        return this.$t('components.modalConfirmation.defaultTitle')
      } else return this.title
    },
    modalText: function () {
      if (!this.text) {
        return this.$t('components.modalConfirmation.defaultText')
      } else return this.text
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 650
    }
  },
  methods: {
    emitDecision (event) {
      this.$emit(event)
      this.show = false
    }
  }
};
</script>
<style scoped>
.w-45 {
  width: 45%;
}
</style>
